import { LegalPageFrame } from '~/components/sections/LegalDocument';
import { cookieContent, type CookieBlock } from '~/content/cookie';

function Block({ block }: { block: CookieBlock }) {
  switch (block.type) {
    case 'paragraph':
      return <p className="text-body text-grey-900">{block.text}</p>;
    case 'list':
      return (
        <ul className="flex list-disc flex-col gap-3 pl-5 text-body text-grey-900 marker:text-grey-500">
          {block.items.map((item) => (
            <li key={item} className="pl-1">
              {item}
            </li>
          ))}
        </ul>
      );
    case 'table': {
      const isSingleColumn = block.columns.length === 1;
      return (
        <table className="w-full border-collapse text-left text-body text-grey-900">
          <thead>
            <tr className="border-b border-black-6">
              {block.columns.map((column) => (
                <th key={column} className="py-3 pr-6 align-top font-semibold text-black last:pr-0">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row) => (
              <tr key={row.join('|')} className="border-b border-black-6 last:border-b-0">
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={
                      isSingleColumn
                        ? 'py-3 align-top'
                        : cellIndex === 0
                          ? 'w-[38%] py-3 pr-6 align-top font-medium text-black'
                          : 'py-3 align-top'
                    }>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  }
}

export function CookiePolicyPage() {
  return (
    <LegalPageFrame>
      <h1 className="text-h3 font-semibold tracking-[-0.03em] text-balance md:text-h2">
        {cookieContent.title}
      </h1>
      <p className="mt-6 text-body-m text-grey-500">Last updated: {cookieContent.lastUpdated}</p>

      <div className="mt-10 max-w-[640px] space-y-6">
        {cookieContent.intro.map((paragraph) => (
          <p key={paragraph} className="text-body text-grey-900">
            {paragraph}
          </p>
        ))}
      </div>

      <div className="mt-[96px] space-y-[84px]">
        {cookieContent.sections.map((section) => (
          <section key={section.number}>
            <h2 className="text-h5 font-semibold tracking-[-0.02em] md:text-h4">
              {section.number}. {section.title}
            </h2>
            <div className="mt-10 space-y-6">
              {section.body.map((block, index) => (
                <Block key={index} block={block} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </LegalPageFrame>
  );
}
